import React from "react";
import { DialogContent, Box, Button, Typography } from "@mui/material";
import RewampDialogShell from "./RewampDialogShell";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

// Pre-apply eligibility/duplicate-application guard (Class G,
// regression/plan/05-PLAN.md Phase 5), ported from dfs-mobile-app's
// SchemeApplyEligibilityDialog — server's own localized `message`, single
// Close button, no override CTA. Shared by CITIZEN (schemeApplyGate.js) and
// AGENT (FarmerContextRoute's SCHEME_APPLY_PROFILE_GET OTP response).
export const RewampApplyEligibilityDialog = ({ open, onClose, reason }) => {
  const { t } = useTranslation();

  return (
    <RewampDialogShell
      open={open}
      onClose={onClose}
      size="standard"
      aria-labelledby="rewamp-apply-eligibility-desc"
    >
      <DialogContent
        sx={{
          p: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <InfoOutlinedIcon aria-hidden="true" sx={{ fontSize: 24, color: "text.textGrey" }} />
          <Typography
            id="rewamp-apply-eligibility-desc"
            variant="h5"
            component="p"
            sx={{ color: "text.textGrey", textAlign: "center" }}
          >
            {reason || t("schemes.applyEligibilityFallbackMessage")}
          </Typography>
        </Box>
        <Button variant="primary" size="card" onClick={onClose} autoFocus>
          {t("schemes.close")}
        </Button>
      </DialogContent>
    </RewampDialogShell>
  );
};

RewampApplyEligibilityDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  /** Server's localized `message[lang]` for the current session's language. */
  reason: PropTypes.string,
};

export default RewampApplyEligibilityDialog;
